import { WrapperGS } from "@ivanlog/gs";
import * as com from "./tmpls";
import { LPXInfrastructure } from "../contracts/LPXInfrastructure";
import { App } from "../App";
import { ERC20Contract } from "../contracts/ERC20Contract";
import { BiMath } from "../libs/BiMath";
import { LPXInfo } from "../api/classes/models";
import { Helper } from "../libs/Helper";
import { CmpInputTokenAmount } from "./CmpInputTokenAmount";
import { CmpWidgetChart } from "./CmpWidgetChart";
import { LPXReserves } from "../contracts/LPXContract";

type ConfigActionValidation = {
    isValid: boolean;
    text: string;
    ntzIndex?: bigint;
    profitIndex?: bigint;
    reserves?: LPXReserves;
    scale?: bigint;
};

type PermissionButton = {
    flag:number;
    label:string;
    button:WrapperGS;
    disabled:boolean;
};

export class CmpWidgetLPXCtrl extends com.CmpWidgetLPXCtrlBase {
    private static readonly DUAL_NTZ_MIN_TEXT = "0.20";
    private static readonly PRICE_CHANGE_COOLDOWN_SECONDS = 12 * 60 * 60;
    private static readonly UINT256_MAX = (1n << 256n) - 1n;

    private _lpxInf:LPXInfrastructure;
    private _pool:LPXInfo;
    private _configValidationTimer:number|undefined;
    private _configPoolTimestamp:bigint = 0n;

    private _resFund:bigint;
    private _resAnchor:bigint;
    private _fundDecimal:bigint = BiMath.Decimal;
    private _anchorDecimal:bigint = BiMath.Decimal;
    private _permissionButtons:PermissionButton[] = [];
    
    constructor() {
        super();
        this.hide();
        const ctrl = this.ctrls;

        ctrl.cmpRemoveLiquidityTokens.ctrls.cmpInputTokenAmount0.ctrls.lSubText.text=
        ctrl.cmpAddLiquidityTokens.ctrls.cmpInputTokenAmount0.ctrls.lSubText.text="Fund";

        ctrl.cmpRemoveLiquidityTokens.ctrls.cmpInputTokenAmount1.ctrls.lSubText.text=
        ctrl.cmpAddLiquidityTokens.ctrls.cmpInputTokenAmount1.ctrls.lSubText.text="Anchor";

        ctrl.cmpRemoveLiquidityTokens.ctrls.cmpInputTokenAmount0.ctrls.iValue.disable();
        ctrl.cmpRemoveLiquidityTokens.ctrls.cmpInputTokenAmount1.ctrls.iValue.disable();

        ctrl.btnAddLiquidity.onclick=async ()=>{
            await App.gui.awaitInLockUIAsync(this._tryAddLiquidityAsync());
        }
        ctrl.btnRemoveLiquidity.onclick=async ()=>{
            await App.gui.awaitInLockUIAsync(this._tryRemoveLiquidityAsync());
        }

        ctrl.rRemoveLiquidityPart.onChangeValue.addHandler((value)=>this._setRemoveRatio(value));
        ctrl.cmpAddLiquidityTokens.ctrls.cmpInputTokenAmount0.ctrls.iValue.el.addEventListener("input",()=>this._setLiqFundValue());
        ctrl.cmpAddLiquidityTokens.ctrls.cmpInputTokenAmount1.ctrls.iValue.el.addEventListener("input",()=>this._setLiqAnchorValue());

        ctrl.tglAddLiquidity.show();

        ctrl.cmpConfigChart?.ctrls.lTitle.hide();
        ctrl.btnSaveIndexes.onclick=async ()=>{ await App.gui.awaitInLockUIAsync(this._trySaveIndexesAsync()); }
        ctrl.btnSavePriceRange.onclick=async ()=>{ await App.gui.awaitInLockUIAsync(this._trySavePriceRangeAsync()); }
        ctrl.btnSaveSellPrice.onclick=async ()=>{ await App.gui.awaitInLockUIAsync(this._trySaveSellPriceAsync()); }
        ctrl.btnToggleAutoDrop.onclick=async ()=>{ await App.gui.awaitInLockUIAsync(this._togglePoolFlagAsync(LPXInfrastructure.PACKFLAG_POOL_PAUSE_AUTO_PRICE_DOWN)); }
        ctrl.btnTogglePause.onclick=async ()=>{ await App.gui.awaitInLockUIAsync(this._togglePoolFlagAsync(LPXInfrastructure.PACKFLAG_POOL_PAUSE_SWAP)); }
        this._permissionButtons = [
            {flag:LPXInfrastructure.PACKFLAG_MANAGER_ONLY, label:"Managed Pool", button:ctrl.btnPermissionManagerOnly, disabled:true},
            {flag:LPXInfrastructure.PACKFLAG_MANAGER_SET_MANAGER, label:"Manager Transfer", button:ctrl.btnPermissionSetManager, disabled:false},
            {flag:LPXInfrastructure.PACKFLAG_MANAGER_SET_POOL_INDEXES, label:"Modify Settings", button:ctrl.btnPermissionSetPoolIndexes, disabled:false},
            {flag:LPXInfrastructure.PACKFLAG_MANAGER_SCALE_POOL_LIQUIDITY, label:"Modify Price Range", button:ctrl.btnPermissionScalePoolLiquidity, disabled:false}
        ];
        for(const permission of this._permissionButtons)
            permission.button.onclick=async ()=>{ await App.gui.awaitInLockUIAsync(this._togglePermissionFlagAsync(permission)); }

        ctrl.cmpConfigNtz.ctrls.iValue.el.addEventListener("input",()=>this._scheduleConfigInfoRefresh());
        ctrl.cmpConfigNtz.ctrls.iValue.el.addEventListener("blur",()=>{
            const ntzIndex = this._getIndex17BFromPercent(ctrl.cmpConfigNtz.ctrls.iValue.value);
            if (ntzIndex !== undefined && ntzIndex < LPXInfrastructure.DUAL_NTZ_MIN_INDEX)
                ctrl.cmpConfigNtz.ctrls.iValue.value = CmpWidgetLPXCtrl.DUAL_NTZ_MIN_TEXT;
            this._refreshConfigInfo();
        });
        ctrl.cmpConfigProfit.onChangeValue.addHandler(()=>this._scheduleConfigInfoRefresh());
        ctrl.cmpConfigMaxSellPrice.ctrls.iValue.el.addEventListener("input",()=>{
            this._refreshConfigInputLines();
            this._scheduleConfigInfoRefresh();
        });
        ctrl.cmpConfigSellPrice.ctrls.iValue.el.addEventListener("input",()=>{
            this._refreshConfigInputLines();
            this._scheduleConfigInfoRefresh();
        });
    }

    private _setRemoveRatio(value){
        this.ctrls.rRemoveLiquidityPart.value=value;
        this.ctrls.cmpRemoveLiquidityTokens.ctrls.cmpInputTokenAmount0.ctrls.iValue.value =
        this.ctrls.cmpRemoveLiquidityTokens.ctrls.cmpInputTokenAmount1.ctrls.iValue.value = "";
        this.ctrls.btnRemoveLiquidity.disable();
        if (this._pool.shareMy.shareRaw=="0") { this.ctrls.rRemoveLiquidityPart.value=0; return;}
        const totalSharesBI = BiMath.WEIToBI(this._pool.sharesTotalRaw);
        if (totalSharesBI==BiMath.Zero) {this.ctrls.rRemoveLiquidityPart.value=0; return;}
        if (value>0) this.ctrls.btnRemoveLiquidity.enable();
        const takeShare = BiMath.WEIToBI(this._pool.shareMy.shareRaw)*BiMath.Decimal/totalSharesBI*BigInt(value)/100n;

        this.ctrls.cmpRemoveLiquidityTokens.ctrls.cmpInputTokenAmount0.ctrls.iValue.value 
            = BiMath.ToEth((this._resFund*takeShare)/BiMath.Decimal*BiMath.Decimal/this._fundDecimal)
        this.ctrls.cmpRemoveLiquidityTokens.ctrls.cmpInputTokenAmount1.ctrls.iValue.value 
            = BiMath.ToEth((this._resAnchor*takeShare)/BiMath.Decimal*BiMath.Decimal/this._anchorDecimal)
    }

    private _setLiqFundValue(){
        const ctrl = this.ctrls.cmpAddLiquidityTokens.ctrls;
        const value = ctrl.cmpInputTokenAmount0.ctrls.iValue.value;
        if (!value) {ctrl.cmpInputTokenAmount1.ctrls.iValue.value=''; return;}
        if (BiMath.WEIToBI(this._pool.reserves.fundRaw)=== 0n) {ctrl.cmpInputTokenAmount1.ctrls.iValue.value=''; return;}
        let valueBi = BiMath.ToBI(value);
        valueBi=valueBi*this._fundDecimal/BiMath.Decimal
        ctrl.cmpInputTokenAmount1.ctrls.iValue.value =
            BiMath.ToEth(
                ((this._resAnchor*BiMath.Decimal)/this._resFund)*valueBi/BiMath.Decimal
                *BiMath.Decimal/this._anchorDecimal
        );
    }
    private _setLiqAnchorValue(){
        const ctrl = this.ctrls.cmpAddLiquidityTokens.ctrls;
        const value = ctrl.cmpInputTokenAmount1.ctrls.iValue.value;
        if (!value) {ctrl.cmpInputTokenAmount0.ctrls.iValue.value=''; return;}
        if (BiMath.WEIToBI(this._pool.reserves.anchorRaw)=== 0n) {ctrl.cmpInputTokenAmount0.ctrls.iValue.value=''; return;}
        let valueBi = BiMath.ToBI(value);
        valueBi=valueBi*this._anchorDecimal/BiMath.Decimal
        ctrl.cmpInputTokenAmount0.ctrls.iValue.value =
            BiMath.ToEth(
                ((this._resFund*BiMath.Decimal)/this._resAnchor)*valueBi/BiMath.Decimal
                *BiMath.Decimal/this._fundDecimal
        );
    }

    public async refreshAsync(pool:LPXInfo)
    {
        await Helper.awaitTime(100);
        const account = App.chain.account;
        this._pool=pool;
        this._resFund = BiMath.WEIToBI(this._pool.reserves.fundRaw);
        this._resAnchor = BiMath.WEIToBI(this._pool.reserves.anchorRaw);

        const lpxInf=App.Inst.getInst(LPXInfrastructure);
        this._lpxInf=lpxInf;

        const fundAdr = this._pool.fundToken.erc20Address;
        const anchorAdr = this._pool.anchorToken.erc20Address;
        this._fundDecimal = BiMath.Pow10(this._pool.fundToken.decimals);
        this._anchorDecimal = BiMath.Pow10(this._pool.anchorToken.decimals);

        const fundSymbol = this._pool.fundToken.symbol;
        const anchorSymbol = this._pool.anchorToken.symbol;
        const ctrl = this.ctrls;

        ctrl.cmpAddLiquidityTokens.ctrls.cmpInputTokenAmount0.ctrls.iValue.value='';
        ctrl.cmpAddLiquidityTokens.ctrls.cmpInputTokenAmount1.ctrls.iValue.value='';

        ctrl.cmpRemoveLiquidityTokens.ctrls.cmpInputTokenAmount0.setToken(fundSymbol, fundAdr);
        ctrl.cmpAddLiquidityTokens.ctrls.cmpInputTokenAmount0.setToken(fundSymbol, fundAdr);

        ctrl.cmpRemoveLiquidityTokens.ctrls.cmpInputTokenAmount1.setToken(anchorSymbol, anchorAdr);
        ctrl.cmpAddLiquidityTokens.ctrls.cmpInputTokenAmount1.setToken(anchorSymbol, anchorAdr);
        this.show();

        if (!account)
        {
            this.hide();
            return;
        }

        ctrl.tglStartPool.show();
        ctrl.tglRemoveLiquidity.show();
        ctrl.tglAddLiquidity.show();
        const isManager = this._isPoolManager();
        const isPoolActive = this._isPoolActive();
        if (isManager) ctrl.tglConfig.show();
        else
        {
            const wasConfigActive = ctrl.tglConfig.isActive || ctrl.tglPermissions.isActive;
            ctrl.tglConfig.hide();
            ctrl.tglConfig.inactive();
            ctrl.blockConfig.hide();
            ctrl.tglPermissions.hide();
            ctrl.tglPermissions.inactive();
            ctrl.blockPermissions.hide();
            if (wasConfigActive) ctrl.tglAddLiquidity.el.click();
        }
        if (isManager)
        {
            const pack = this._lpxInf.unpackConfigPack(BiMath.WEIToBI(pool.packRaw));
            const reserves = LPXReserves.FromLPXInfo(pool);
            const baseIndex = pack.ntzIndex - pack.feeIndex * 2n;
            let harvest = 0;
            if (baseIndex > 0n) harvest = Number(pack.profitIndex * 100n / baseIndex);
            if (pack.managerRewardIndex > 0n) harvest = 100;
            if (harvest < 0) harvest = 0;
            if (harvest > 100) harvest = 100;

            ctrl.cmpConfigNtz.ctrls.iValue.value = this._index17BToPercentText(pack.ntzIndex);
            ctrl.cmpConfigProfit.value = harvest;
            ctrl.cmpConfigMaxSellPrice.setToken(anchorSymbol, anchorAdr);
            ctrl.cmpConfigSellPrice.setToken(anchorSymbol, anchorAdr);

            const published = this._getPublishedPrices(reserves, pack);
            ctrl.cmpConfigMaxSellPrice.ctrls.iValue.value = published.maxSellPrice > 0n ? this._formatPrice(published.maxSellPrice) : "";
            ctrl.cmpConfigSellPrice.ctrls.iValue.value = published.sellPrice > 0n ? this._formatPrice(published.sellPrice) : "";

            try { this._configPoolTimestamp = await this._lpxInf.lpxCtrlPoolMngr.poolsTimestampsAsync(pool.poolId); }
            catch (e) { console.error(e); this._configPoolTimestamp = 0n; }

            const packRaw = BiMath.WEIToBI(this._pool.packRaw);
            const isAutoDropPaused = this._lpxInf.hasFlag(packRaw, LPXInfrastructure.PACKFLAG_POOL_PAUSE_AUTO_PRICE_DOWN);
            const isPaused = this._lpxInf.hasFlag(packRaw, LPXInfrastructure.PACKFLAG_POOL_PAUSE_SWAP);
            ctrl.btnToggleAutoDrop.text = isAutoDropPaused ? "Auto Price Drop: Off" : "Auto Price Drop: On";
            ctrl.btnTogglePause.text = isPaused ? "Trading: Paused" : "Trading: Active";

            if (!isPoolActive)
            {
                ctrl.tglPermissions.show();

                const packRaw = BiMath.WEIToBI(this._pool.packRaw);
                for(const permission of this._permissionButtons)
                {
                    const enabled = this._lpxInf.hasFlag(packRaw, permission.flag);
                    permission.button.text = permission.label + ": " + (enabled ? "On" : "Off");
                    if (enabled) permission.button.active();
                    else permission.button.inactive();
                    permission.button.enableSet(!permission.disabled);
                }
                ctrl.lPermissionsInfo.text = "Click a permission to update it before pool start.";
            } else
            {
                const wasPermissionsActive = ctrl.tglPermissions.isActive;
                ctrl.tglPermissions.hide();
                ctrl.tglPermissions.inactive();
                ctrl.blockPermissions.hide();
                if (wasPermissionsActive) ctrl.tglAddLiquidity.el.click();
            }

            if (isPoolActive)
            {
                ctrl.tglConfigPriceRange.show();
                ctrl.tglConfigSellPrice.show();
            }
            else
            {
                const wasPriceTabActive = ctrl.tglConfigPriceRange.isActive || ctrl.tglConfigSellPrice.isActive;
                ctrl.tglConfigPriceRange.hide();
                ctrl.tglConfigSellPrice.hide();
                ctrl.tglConfigPriceRange.inactive();
                ctrl.tglConfigSellPrice.inactive();
                ctrl.blockConfigPriceRange.hide();
                ctrl.blockConfigSellPrice.hide();
                if (wasPriceTabActive || !ctrl.tglConfigSettings.isActive) ctrl.tglConfigSettings.el.click();
            }

            this._refreshConfigInfo();
            ctrl.cmpConfigChart?.loadLPXAsync(pool);
            window.setTimeout(()=>ctrl.cmpConfigProfit.draw(), 0);
        }

        if (!isPoolActive)
        {
            ctrl.tglRemoveLiquidity.hide();
            ctrl.tglAddLiquidity.hide();
            ctrl.tglStartPool.el.click();
            await ctrl.blockStartPool.refreshAsync(pool);
        } else 
        {
            ctrl.tglStartPool.hide();
            if (BiMath.WEIToBI(this._pool.shareMy.shareRaw)==0n)
            {
                if (!ctrl.tglConfig.isActive) ctrl.tglAddLiquidity.el.click();
                ctrl.tglRemoveLiquidity.hide();
            } else if (ctrl.tglStartPool.active)
                ctrl.tglAddLiquidity.el.click();
            this._setRemoveRatio(0);
        }

    }

    private _refreshConfigInfo()
    {
        const ctrl = this.ctrls;
        if (!this._pool || !this._lpxInf) return;

        const indexesValidation = this._getConfigIndexesValidation();
        ctrl.lConfigIndexesInfo.text = indexesValidation.text;
        ctrl.btnSaveIndexes.enableSet(indexesValidation.isValid);

        const priceRangeValidation = this._getPriceRangeValidation();
        ctrl.lConfigPriceRangeInfo.text = priceRangeValidation.text;
        ctrl.btnSavePriceRange.enableSet(priceRangeValidation.isValid);

        const sellPriceValidation = this._getSellPriceValidation();
        ctrl.lConfigSellInfo.text = sellPriceValidation.text;
        ctrl.btnSaveSellPrice.enableSet(sellPriceValidation.isValid);

        this._refreshConfigInputLines(priceRangeValidation);
    }

    private _refreshConfigInputLines(priceRangeValidation?:ConfigActionValidation)
    {
        const ctrl = this.ctrls;
        if (!ctrl.cmpConfigChart || !this._pool || !this._lpxInf) return;

        const maxSellInput = this._getInputNumber(ctrl.cmpConfigMaxSellPrice);
        ctrl.cmpConfigChart.setLinePrice(CmpWidgetChart.LINE_MAX_SELL, maxSellInput);
        ctrl.cmpConfigChart.setLinePrice(CmpWidgetChart.LINE_MIN_BUY, 0);

        priceRangeValidation ??= this._getPriceRangeValidation();
        if (priceRangeValidation.reserves)
        {
            const pack = this._lpxInf.unpackConfigPack(BiMath.WEIToBI(this._pool.packRaw));
            const published = this._getPublishedPrices(priceRangeValidation.reserves, pack);
            ctrl.cmpConfigChart.setLinePrice(CmpWidgetChart.LINE_MAX_SELL, parseFloat(BiMath.ToEth(published.maxSellPrice)));
            ctrl.cmpConfigChart.setLinePrice(CmpWidgetChart.LINE_MIN_BUY, parseFloat(BiMath.ToEth(published.minBuyPrice)));
        }

        const sellInput = this._getInputNumber(ctrl.cmpConfigSellPrice);
        ctrl.cmpConfigChart.setLinePrice(CmpWidgetChart.LINE_SELL, sellInput);
        ctrl.cmpConfigChart.setLinePrice(CmpWidgetChart.LINE_BUY, 0);

        const targetSellPriceRaw = this._getPriceRawFromInput(ctrl.cmpConfigSellPrice);
        if (targetSellPriceRaw === undefined || targetSellPriceRaw <= 0n) return;

        const pack = this._lpxInf.unpackConfigPack(BiMath.WEIToBI(this._pool.packRaw));
        const buyPrice = targetSellPriceRaw*(BiMath.Decimal17B-pack.ntzIndex)/BiMath.Decimal17B*this._fundDecimal/this._anchorDecimal;
        ctrl.cmpConfigChart.setLinePrice(CmpWidgetChart.LINE_BUY, parseFloat(BiMath.ToEth(buyPrice)));
    }

    private _scheduleConfigInfoRefresh()
    {
        if (this._configValidationTimer !== undefined) window.clearTimeout(this._configValidationTimer);
        this._configValidationTimer = window.setTimeout(()=>{
            this._configValidationTimer = undefined;
            this._refreshConfigInfo();
        }, 250);
    }

    private _getConfigIndexesValidation():ConfigActionValidation
    {
        const ctrl = this.ctrls;
        const invalid = (text:string):ConfigActionValidation=>({isValid:false, text});
        if (!this._pool || !this._lpxInf) return invalid("");
        if (!this._isPoolManager()) return invalid("Manager wallet required.");

        const packRaw = BiMath.WEIToBI(this._pool.packRaw);
        const pack = this._lpxInf.unpackConfigPack(packRaw);
        if (pack.poolType != LPXInfrastructure.POOLTYPE_DUAL)
            return invalid("NTZ and Harvest/Compound can be changed only for Custom LPX.");

        const ntzIndex = this._getIndex17BFromPercent(ctrl.cmpConfigNtz.ctrls.iValue.value);
        if (ntzIndex === undefined) return invalid("Enter NTZ.");
        if (ntzIndex < LPXInfrastructure.DUAL_NTZ_MIN_INDEX)
            return invalid(`NTZ must be at least ${CmpWidgetLPXCtrl.DUAL_NTZ_MIN_TEXT}%.`);

        let feeIndex = ntzIndex*LPXInfrastructure.DUAL_FEE_FROM_NTZ_INDEX/BiMath.Decimal17B;
        if (feeIndex<LPXInfrastructure.DUAL_FEE_MIN_INDEX) feeIndex=LPXInfrastructure.DUAL_FEE_MIN_INDEX;
        const grossProfitIndex = ntzIndex - feeIndex * 2n;
        if (grossProfitIndex < 0n)
            return invalid(`NTZ must be at least ${CmpWidgetLPXCtrl.DUAL_NTZ_MIN_TEXT}%.`);

        let harvest = BigInt(ctrl.cmpConfigProfit.value);
        let profitIndex = grossProfitIndex * harvest / 100n;
        let lockText = "";
        if (pack.managerRewardIndex > 0n)
        {
            harvest = 100n;
            profitIndex = grossProfitIndex;
            lockText = "\nManager reward is enabled, so Harvest is fixed at 100%.";
        }

        const compound = 100n - harvest;
        let text = `NTZ: ${this._index17BToPercentText(ntzIndex)}%\n`;
        text += `Fee: ${this._index17BToPercentText(feeIndex)}%\n`;
        text += `Harvest: ${harvest}%\n`;
        text += `Compound: ${compound}%${lockText}`;

        const hasIndexFlag = this._lpxInf.hasFlag(packRaw, LPXInfrastructure.PACKFLAG_MANAGER_SET_POOL_INDEXES);
        if (!hasIndexFlag && this._isPoolActive())
            return invalid(text + "\nModify Settings permission is not granted. It can only be granted before pool start.");
        if (!hasIndexFlag)
            return invalid(text + "\nGrant Modify Settings permission before saving.");

        return {isValid:true, text, ntzIndex, profitIndex};
    }

    private _getPriceRangeValidation():ConfigActionValidation
    {
        const invalid = (text:string):ConfigActionValidation=>({isValid:false, text});
        if (!this._pool || !this._lpxInf) return invalid("");
        if (!this._isPoolManager()) return invalid("Manager wallet required.");
        if (!this._isPoolActive()) return invalid("Price range can be changed only after pool start.");

        const targetMaxSellPriceRaw = this._getPriceRawFromInput(this.ctrls.cmpConfigMaxSellPrice);
        if (targetMaxSellPriceRaw === undefined || targetMaxSellPriceRaw <= 0n) return invalid("Enter Max Sell Price.");

        const packRaw = BiMath.WEIToBI(this._pool.packRaw);
        if (!this._lpxInf.hasFlag(packRaw, LPXInfrastructure.PACKFLAG_MANAGER_SCALE_POOL_LIQUIDITY))
            return invalid("Price Range requires Modify Price Range permission.");

        const pack = this._lpxInf.unpackConfigPack(BiMath.WEIToBI(this._pool.packRaw));
        const reserves = LPXReserves.FromLPXInfo(this._pool);
        const currentRatioRaw = this._lpxInf.calcCurrentRatio(reserves);
        const fundTotal = reserves.fundReserve + reserves.fundImgReserve;
        const anchorTotal = reserves.anchorReserve + reserves.anchorImgReserve;
        if (fundTotal <= 0n || anchorTotal <= 0n) return invalid("Pool reserves are empty.");
        if (targetMaxSellPriceRaw <= currentRatioRaw) return invalid("Max Sell Price must be above current Sell Price.");

        let scaleResult:{scale:bigint; reserves:LPXReserves};
        try { scaleResult = this._solveScaleForMaxSellPrice(reserves, pack, targetMaxSellPriceRaw); }
        catch (e:any) { return invalid(e?.message ? e.message + "" : "Can't calculate scale for this Max Sell Price."); }

        const published = this._getPublishedPrices(scaleResult.reserves, pack);
        const text =
            "Published Max Sell Price: " + this._formatPrice(published.maxSellPrice) + "\n" +
            "Published Min Buy Price: " + this._formatPrice(published.minBuyPrice) + "\n" +
            "Sell Price remains: " + this._formatPrice(published.sellPrice) + "\n" +
            "Scale: " + BiMath.TruncEth(BiMath.ToEth(scaleResult.scale), 6) + "x";
        return {isValid:true, text, reserves:scaleResult.reserves, scale:scaleResult.scale};
    }

    private _getSellPriceValidation():ConfigActionValidation
    {
        const invalid = (text:string):ConfigActionValidation=>({isValid:false, text});
        if (!this._pool || !this._lpxInf) return invalid("");
        if (!this._isPoolManager()) return invalid("Manager wallet required.");
        if (!this._isPoolActive()) return invalid("Sell Price can be changed only after pool start.");

        const cooldownSeconds = this._getPriceChangeCooldownSeconds();
        if (cooldownSeconds > 0) return invalid("Sell Price cooldown: " + this._formatDuration(cooldownSeconds) + ".");

        const targetSellPriceRaw = this._getPriceRawFromInput(this.ctrls.cmpConfigSellPrice);
        if (targetSellPriceRaw === undefined || targetSellPriceRaw <= 0n) return invalid("Enter Sell Price.");

        const pack = this._lpxInf.unpackConfigPack(BiMath.WEIToBI(this._pool.packRaw));
        const reserves = LPXReserves.FromLPXInfo(this._pool);
        const currentSellPriceRaw = this._lpxInf.calcCurrentRatio(reserves);
        if (!this._isWithinTenPercent(targetSellPriceRaw, currentSellPriceRaw))
            return invalid("Sell Price can move only within +/-10% every 12hr.");

        let nextReserves:LPXReserves;
        try
        {
            const currentFundTotal = reserves.fundReserve + reserves.fundImgReserve;
            const currentAnchorTotal = reserves.anchorReserve + reserves.anchorImgReserve;
            if (currentFundTotal <= 0n || currentAnchorTotal <= 0n) throw new Error("Pool reserves are empty.");

            const currentK = currentFundTotal * currentAnchorTotal;
            const sqrtValue = currentK * BiMath.Decimal / targetSellPriceRaw;
            let fundTotal = sqrtValue;
            if (sqrtValue >= 2n)
            {
                let x0 = sqrtValue / 2n;
                let x1 = (x0 + sqrtValue / x0) / 2n;
                while (x1 < x0)
                {
                    x0 = x1;
                    x1 = (x0 + sqrtValue / x0) / 2n;
                }
                fundTotal = x0;
            }

            const minFundByAnchor = (reserves.anchorReserve * BiMath.Decimal + targetSellPriceRaw - 1n) / targetSellPriceRaw;
            if (fundTotal < reserves.fundReserve) fundTotal = reserves.fundReserve;
            if (fundTotal < minFundByAnchor) fundTotal = minFundByAnchor;

            let anchorTotal = (fundTotal * targetSellPriceRaw + BiMath.Decimal - 1n) / BiMath.Decimal;
            if (anchorTotal < reserves.anchorReserve) anchorTotal = reserves.anchorReserve;

            nextReserves = new LPXReserves();
            nextReserves.fundReserve = reserves.fundReserve;
            nextReserves.anchorReserve = reserves.anchorReserve;
            nextReserves.fundImgReserve = fundTotal - reserves.fundReserve;
            nextReserves.anchorImgReserve = anchorTotal - reserves.anchorReserve;
        }
        catch (e:any) { return invalid(e?.message ? e.message + "" : "Can't calculate reserves for this Sell Price."); }

        const safetyError = this._validateImgReservesSafety(reserves, nextReserves);
        if (safetyError) return invalid(safetyError);

        const published = this._getPublishedPrices(nextReserves, pack);
        const text =
            "Published Sell Price: " + this._formatPrice(published.sellPrice) + "\n" +
            "Published Max Sell Price: " + this._formatPrice(published.maxSellPrice) + "\n" +
            "Published Min Buy Price: " + this._formatPrice(published.minBuyPrice);
        return {isValid:true, text, reserves:nextReserves};
    }

    private async _trySaveIndexesAsync()
    {
        const validation = this._getConfigIndexesValidation();
        if (!validation.isValid || validation.ntzIndex === undefined || validation.profitIndex === undefined)
        {
            App.gui.dialogOkShowAsync(validation.text);
            return;
        }

        const result = await this._lpxInf.lpxCtrlPoolMngr.managerSetPoolIndexesAsync(this._pool.poolId, validation.ntzIndex, validation.profitIndex);
        if (result) this._informTxSuccessful();
        await this._lpxInf.refreshAsync();
    }

    private async _trySavePriceRangeAsync()
    {
        const validation = this._getPriceRangeValidation();
        if (!validation.isValid || validation.scale === undefined)
        {
            App.gui.dialogOkShowAsync(validation.text);
            return;
        }

        const result = await this._lpxInf.lpxCtrlPoolMngr.managerScalePoolLiquidityAsync(this._pool.poolId, validation.scale);
        if (result) this._informTxSuccessful();
        await this._lpxInf.refreshAsync();
    }

    private async _trySaveSellPriceAsync()
    {
        const validation = this._getSellPriceValidation();
        if (!validation.isValid || !validation.reserves)
        {
            App.gui.dialogOkShowAsync(validation.text);
            return;
        }

        const result = await this._lpxInf.lpxCtrlPoolMngr.managerSetPoolImgReservesAsync(
            this._pool.poolId,
            validation.reserves.fundImgReserve,
            validation.reserves.anchorImgReserve
        );
        if (result) this._informTxSuccessful();
        await this._lpxInf.refreshAsync();
    }

    private async _togglePermissionFlagAsync(permission:PermissionButton)
    {
        if (!this._pool || !this._lpxInf || !this._isPoolManager()) return;
        if (permission.disabled) return;
        if (this._isPoolActive())
        {
            App.gui.dialogOkShowAsync("Manager permissions can be changed only before pool start.");
            return;
        }

        const packRaw = BiMath.WEIToBI(this._pool.packRaw);
        const value = !this._lpxInf.hasFlag(packRaw, permission.flag);
        const result = await this._lpxInf.lpxCtrlPoolMngr.managerSetPoolsAccessFlagAsync([this._pool.poolId], permission.flag, value);
        if (result) this._informTxSuccessful();
        await this._lpxInf.refreshAsync();
    }

    private async _togglePoolFlagAsync(flag:number)
    {
        if (!this._pool || !this._lpxInf || !this._isPoolManager()) return;
        const packRaw = BiMath.WEIToBI(this._pool.packRaw);
        const value = !this._lpxInf.hasFlag(packRaw, flag);
        const result = await this._lpxInf.lpxCtrlPoolMngr.managerSetPoolsFlagAsync([this._pool.poolId], flag, value);
        if (result) this._informTxSuccessful();
        await this._lpxInf.refreshAsync();
    }

    private _isPoolManager()
    {
        const account = App.chain.account;
        if (!account || !this._pool?.managerAddress) return false;
        return account.toLowerCase() == this._pool.managerAddress.toLowerCase();
    }

    private _isPoolActive()
    {
        if (!this._pool) return false;
        return BiMath.WEIToBI(this._pool.sharesTotalRaw) > 0n;
    }

    private _getIndex17BFromPercent(value:string)
    {
        value = value.trim();
        if (!value) return undefined;
        if (value.charAt(0)==".") value = "0"+value;
        if (!/^[0-9]+(\.[0-9]{0,3})?$/.test(value)) return undefined;

        const parts = value.split(".");
        const integerPart = BigInt(parts[0]);
        const decimalPart = BigInt((parts[1]??"").padEnd(3, "0").slice(0, 3));
        return integerPart*1000n+decimalPart;
    }

    private _index17BToPercentText(index:bigint)
    {
        const integerPart = index / 1000n;
        const decimalPart = index % 1000n;
        if (decimalPart == 0n) return integerPart + "";
        return `${integerPart}.${decimalPart.toString().padStart(3, "0").replace(/0+$/, "")}`;
    }

    private _getPriceRawFromInput(input:CmpInputTokenAmount|undefined)
    {
        if (!input) return undefined;
        let value = input.ctrls.iValue.value.trim();
        if (!value) return undefined;
        if (value.charAt(0)==".") value = "0"+value;
        if (!/^[0-9]+(\.[0-9]{0,18})?$/.test(value)) return undefined;
        return BiMath.ToBI(value) * this._anchorDecimal / this._fundDecimal;
    }

    private _getInputNumber(input:CmpInputTokenAmount)
    {
        const value = parseFloat(input.ctrls.iValue.value.trim());
        if (!Number.isFinite(value) || value <= 0) return 0;
        return value;
    }

    private _solveScaleForMaxSellPrice(source:LPXReserves, pack:any, targetMaxSellPrice:bigint)
    {
        const getResult = (scale:bigint)=>{
            const reserves = this._getScaledReserves(source, scale);
            const maxSellPrice = reserves.fundImgReserve > 0n ? this._lpxInf.calcEndRatio(reserves, pack.feeIndex) : 0n;
            return {scale, reserves, maxSellPrice};
        };
        const isAboveTarget = (maxSellPrice:bigint)=>maxSellPrice == 0n || maxSellPrice > targetMaxSellPrice;

        let low = BiMath.Decimal;
        let high = BiMath.Decimal;
        let result = getResult(high);
        if (result.maxSellPrice > 0n && result.maxSellPrice < targetMaxSellPrice)
            throw new Error("Max Sell Price is outside scale range.");

        while (isAboveTarget(result.maxSellPrice))
        {
            low = high;
            high *= 2n;
            result = getResult(high);
        }

        while (high - low > 1n)
        {
            const mid = (low + high) / 2n;
            const midResult = getResult(mid);
            if (isAboveTarget(midResult.maxSellPrice)) low = mid;
            else
            {
                high = mid;
                result = midResult;
            }
        }

        if (result.maxSellPrice == 0n) throw new Error("Max Sell Price is outside scale range.");
        return {scale:result.scale, reserves:result.reserves};
    }

    private _getScaledReserves(source:LPXReserves, scale:bigint)
    {
        const ceilDiv = (a:bigint, b:bigint)=>{
            if (b <= 0n) throw new Error("Scale division by zero.");
            if (a == 0n) return 0n;
            return ((a - 1n) / b) + 1n;
        };
        const safeMul = (a:bigint, b:bigint)=>{
            if (a == 0n || b == 0n) return 0n;
            if (b > CmpWidgetLPXCtrl.UINT256_MAX / a) throw new Error("Scale is too high.");
            return a*b;
        };
        const gcd = (a:bigint, b:bigint)=>{
            while (b != 0n)
            {
                const c = a % b;
                a = b;
                b = c;
            }
            return a;
        };

        const fundTotal = source.fundReserve + source.fundImgReserve;
        const anchorTotal = source.anchorReserve + source.anchorImgReserve;
        if (fundTotal <= 0n || anchorTotal <= 0n) throw new Error("Pool reserves are empty.");

        const ratioGcd = gcd(fundTotal, anchorTotal);
        const fundBase = fundTotal / ratioGcd;
        const anchorBase = anchorTotal / ratioGcd;
        const minKFund = ceilDiv(source.fundReserve, fundBase);
        const minKAnchor = ceilDiv(source.anchorReserve, anchorBase);
        const minK = minKFund > minKAnchor ? minKFund : minKAnchor;
        const targetK = ceilDiv(safeMul(minK, scale), BiMath.Decimal);

        const reserves = new LPXReserves();
        reserves.fundReserve = source.fundReserve;
        reserves.anchorReserve = source.anchorReserve;
        reserves.fundImgReserve = safeMul(fundBase, targetK) - source.fundReserve;
        reserves.anchorImgReserve = safeMul(anchorBase, targetK) - source.anchorReserve;
        return reserves;
    }

    private _getPublishedPrices(reserves:LPXReserves, pack:any)
    {
        const pairDecimalCor = this._fundDecimal*BiMath.Decimal/this._anchorDecimal;
        let sellPrice = 0n;
        let buyPrice = 0n;
        let maxSellPrice = 0n;
        let minBuyPrice = 0n;

        if (reserves.fundReserve + reserves.fundImgReserve > 0n)
        {
            const currentRatio = this._lpxInf.calcCurrentRatio(reserves);
            sellPrice = currentRatio*pairDecimalCor/BiMath.Decimal;
            buyPrice = currentRatio*(BiMath.Decimal17B-pack.ntzIndex)/BiMath.Decimal17B*pairDecimalCor/BiMath.Decimal;
        }
        if (reserves.fundImgReserve > 0n)
            maxSellPrice = this._lpxInf.calcEndRatio(reserves, pack.feeIndex)*pairDecimalCor/BiMath.Decimal;
        if (reserves.anchorImgReserve > 0n)
            minBuyPrice = this._lpxInf.calcStartRatio(reserves, pack.feeIndex)
                *(BiMath.Decimal17B-pack.ntzIndex)/BiMath.Decimal17B
                *pairDecimalCor/BiMath.Decimal;

        return { sellPrice, buyPrice, maxSellPrice, minBuyPrice };
    }

    private _formatPrice(price:bigint)
    {
        return BiMath.TruncEth(BiMath.ToEth(price), 12);
    }

    private _getPriceChangeCooldownSeconds()
    {
        if (this._configPoolTimestamp == 0n) return 0;
        const nextChange = Number(this._configPoolTimestamp) + CmpWidgetLPXCtrl.PRICE_CHANGE_COOLDOWN_SECONDS;
        const now = Math.floor(Date.now()/1000);
        if (nextChange <= now) return 0;
        return nextChange - now;
    }

    private _formatDuration(totalSeconds:number)
    {
        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.ceil((totalSeconds % 3600) / 60);
        if (hours <= 0) return `${minutes}m`;
        if (minutes <= 0 || minutes == 60) return `${hours + (minutes == 60 ? 1 : 0)}h`;
        return `${hours}h ${minutes}m`;
    }

    private _validateImgReservesSafety(current:LPXReserves, next:LPXReserves)
    {
        const currentFundTotal = current.fundReserve + current.fundImgReserve;
        const currentAnchorTotal = current.anchorReserve + current.anchorImgReserve;
        const nextFundTotal = next.fundReserve + next.fundImgReserve;
        const nextAnchorTotal = next.anchorReserve + next.anchorImgReserve;
        if (nextFundTotal <= 0n || nextAnchorTotal <= 0n) return "Published reserves must be greater than zero.";

        const currentRatio = this._lpxInf.calcCurrentRatio(current);
        const nextRatio = this._lpxInf.calcCurrentRatio(next);
        if (!this._isWithinTenPercent(nextRatio, currentRatio))
            return "Current ratio must stay within +/-10%.";

        const currentK = currentFundTotal * currentAnchorTotal;
        const nextK = nextFundTotal * nextAnchorTotal;
        if (!this._isWithinTenPercent(nextK, currentK))
            return "Effective liquidity must stay within +/-10%.";

        return "";
    }

    private _isWithinTenPercent(value:bigint, base:bigint)
    {
        if (base == 0n) return value == 0n;
        return value*10n >= base*9n && value*10n <= base*11n;
    }

    private async _tryAddLiquidityAsync()
    {
        const fundAdr = this._pool.fundToken.erc20Address;
        const anchorAdr = this._pool.anchorToken.erc20Address;
        const valueFund = this.ctrls.cmpAddLiquidityTokens.ctrls.cmpInputTokenAmount0.ctrls.iValue.value;
        const valueAnchor = this.ctrls.cmpAddLiquidityTokens.ctrls.cmpInputTokenAmount1.ctrls.iValue.value;
        let valueFundBi = BiMath.ToBI(valueFund)*this._fundDecimal/BiMath.Decimal;
        let valueAnchorBi = BiMath.ToBI(valueAnchor)*this._anchorDecimal/BiMath.Decimal*BigInt(1001)/BigInt(1000);
        let valuePayBi=BiMath.Zero;

        const erc20Fund = new ERC20Contract(fundAdr, App.chain.provider);
        const erc20Anchor = new ERC20Contract(anchorAdr, App.chain.provider);
        const balanceEth = await App.chain.getBalanceEth();
        if (balanceEth === undefined)
        {
            App.gui.dialogOkShowAsync("Unable to read wallet balance. Please reconnect wallet and try again.");
            return;
        }

        if (fundAdr!=LPXInfrastructure.ADDRESS_WPLS)
        {
            const balanceFund = await erc20Fund.balanceOf(App.chain.account);
            if (BiMath.ToBI(balanceFund)<valueFundBi) 
            {
                App.gui.dialogOkShowAsync("Insufficient funds");
                return;
            }
        } else
        {
            if (BiMath.ToBI(balanceEth)<valueFundBi)
            {
                App.gui.dialogOkShowAsync("Insufficient funds");
                return;
            }
            valuePayBi = valueFundBi;
        }

        if (anchorAdr!=LPXInfrastructure.ADDRESS_WPLS)
        {
            const balanceAnchor = await erc20Anchor.balanceOf(App.chain.account);
            if (BiMath.ToBI(balanceAnchor)<valueAnchorBi) 
            {
                App.gui.dialogOkShowAsync("Insufficient anchor");
                return;
            }
        } else
        {
            if (BiMath.ToBI(balanceEth)<valueAnchorBi)
            {
                App.gui.dialogOkShowAsync("Insufficient anchor");
                return;
            }
            valuePayBi = valueAnchorBi;
        }

        const stepTx0 = App.gui.getTxLockText();
        const stepTx1="1/2 Transaction in progress.\nToken approval pending.\nPlease wait for it to finish.\nThis may take a few minutes.\n\nThe second transaction will start automatically.";
        const stepTx2="2/2 Transaction in progress.\nPlease wait for it to finish.\nThis may take a few minutes";

        if (fundAdr!=LPXInfrastructure.ADDRESS_WPLS)
        {
            const approved = await erc20Fund.allowance(App.chain.account, this._lpxInf.lpx.address);
            if (BiMath.ToBI(approved)<valueFundBi)
            {
                App.gui.setTxLockText(stepTx1);
                const approveResult = await erc20Fund.approve(this._lpxInf.lpx.address, BiMath.ToEth(valueFundBi));
                if (!approveResult) {App.gui.setTxLockText(stepTx0); return;}
                App.gui.setTxLockText(stepTx2);
            }
        } 
        if (anchorAdr!=LPXInfrastructure.ADDRESS_WPLS)
        {
            const approved = await erc20Anchor.allowance(App.chain.account, this._lpxInf.lpx.address);
            if (BiMath.ToBI(approved)<valueAnchorBi)
            {
                App.gui.setTxLockText(stepTx1);
                const approveResult = await erc20Anchor.approve(this._lpxInf.lpx.address, BiMath.ToEth(valueAnchorBi));
                if (!approveResult) {App.gui.setTxLockText(stepTx0); return;}
                App.gui.setTxLockText(stepTx2);
            }
        }
        const result = await this._lpxInf.lpxCtrlPools.addLiquidity(BiMath.ToEth(valuePayBi), this._pool.poolId, BiMath.ToEth(valueFundBi), BiMath.ToEth(valueAnchorBi));
        if (result) this._informTxSuccessful();
        App.gui.setTxLockText(stepTx0);
        this._lpxInf.refreshAsync();
    }

    
    private async _tryRemoveLiquidityAsync()
    {
        const value = this.ctrls.rRemoveLiquidityPart.value;
        if (!value) return;
        const share = await this._lpxInf.lpx.shares(this._pool.poolId, App.chain.account);
        if (!share) { return; }
        const takeShare = share.share*BigInt(value)/BigInt(100);
        const result = await this._lpxInf.lpxCtrlPools.removeLiquidity(this._pool.poolId,BiMath.ToEth(takeShare));
        if (result) this._informTxSuccessful();
        this._lpxInf.refreshAsync();
    }

    private _informTxSuccessful() { App.gui.dialogOkShowAsync("Transaction successful!","") }
}
